'use client'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import React, { FunctionComponent, type JSX } from 'react'

interface MasterPageProps {
  children: React.ReactNode
  slideoutElement?: JSX.Element
  slideoutPortalID?: string
  breadcrumbs?: {
    name: string
    route: string
    active?: boolean
  }[]
  header?: {
    title: string
    subText?: string
    // Rendered before the title, top left — where a back control is expected.
    back?: JSX.Element | false
    // Rendered beside the title, top left. For a page's primary action.
    action?: JSX.Element | false
  }
  action?: JSX.Element | false
}

export const MasterPage: FunctionComponent<MasterPageProps> = (
  props: MasterPageProps
) => {
  // With nothing to put in it the header row still rendered, and its `py-2`
  // pushed the content down by 16px of empty space. Only the dashboard hits
  // this — every other page passes breadcrumbs or a header.
  const hasHeaderRow = Boolean(
    props.breadcrumbs || props.header || props.action
  )

  return (
    <div className="flex h-full w-full justify-between bg-white">
      <div className="flex h-full min-h-0 w-full flex-col gap-y-2 px-3 pb-3">
        {hasHeaderRow && (
          <div className="flex h-auto w-full flex-row justify-between py-2">
            <div className="flex min-w-[200px] flex-col justify-around gap-y-2">
              {props.breadcrumbs && <Breadcrumbs crumbs={props.breadcrumbs} />}
              {props.header && (
                <div className="flex flex-col">
                  <div className="flex flex-row items-center gap-3">
                    {props.header.back}
                    <span className="text-xl font-bold text-[var(--mantine-color-celerityBrand-9)]">
                      {props.header.title}
                    </span>
                    {props.header.action}
                  </div>
                  {props.header.subText && <span>{props.header.subText}</span>}
                </div>
              )}
            </div>
            {props.action && <div className="self-end">{props.action}</div>}
          </div>
        )}
        <div className="min-h-0 w-full flex-1">{props.children}</div>
      </div>
      {props.slideoutElement && (
        <div className="h-full w-[55px]">{props.slideoutElement}</div>
      )}
      {!props.slideoutElement && props.slideoutPortalID && (
        <div className="h-full w-[55px]">
          <div id={props.slideoutPortalID} className="h-full" />
        </div>
      )}
    </div>
  )
}
